import '@fontsource-variable/inter';
import '@fontsource-variable/lora';
import '@fontsource-variable/lora/wght-italic.css';
import './src/styles/global.css';

import React from 'react';
import { useTrackingInit } from './src/hooks/useTrackingInit';

function TrackingInit({ children }) {
  useTrackingInit();
  return children;
}

export const wrapPageElement = ({ element }) => (
  <TrackingInit>{element}</TrackingInit>
);
